// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Loads/GeneralLoading/CharacteristicsLoading/styles.scss
// module id = 1320
// module chunks = 0